import { UrlMatchResult, UrlSegment } from '@angular/router';
import { ENTITY_TYPE } from '../../../shared/typings/types/entity-type.types';

const PROFILE_ENTITY_TYPES: ENTITY_TYPE[] = [ENTITY_TYPE.SCHOOL, ENTITY_TYPE.SHELTER];

/**
 * Matches the entity-profile leaf of an OP entity URL, e.g.
 *   .../<entityType>/multi/:networkId/school
 *   .../<entityType>/multi/:networkId/school/:schoolId
 *   .../<entityType>/multi/:networkId/shelter
 *   .../<entityType>/multi/:networkId/shelter/:shelterId
 *
 * The leading segment is the entity-type marker; the optional second segment
 * identifies the specific entity whose profile to show. It is emitted as a
 * type-specific param (`schoolId` / `shelterId`) — NOT `entityId` — so that:
 *   - `UrlNavigationService.getEntityMode` keeps the route in MULTI_ENTITY mode
 *     (an `entityId` param would flip it to SINGLE_ENTITY and render a student
 *     profile instead), and
 *   - `StudentComponent.initMultiEntitySchoolProfile` can read it via
 *     `params.schoolId || params.shelterId`.
 */
export function entityProfileMatcher (segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length === 0) return null;

  const [typeSegment, idSegment] = segments;
  if (!PROFILE_ENTITY_TYPES.includes(typeSegment.path as ENTITY_TYPE)) return null;

  if (segments.length === 1) return { consumed: segments, posParams: {} };
  if (segments.length === 2) return { consumed: segments, posParams: { [`${typeSegment.path}Id`]: idSegment } };

  return null;
}
